import { render, staticRenderFns } from "./20240914.vue?vue&type=template&id=21f88a64&scoped=true&"
import script from "./20240914.vue?vue&type=script&lang=js&"
export * from "./20240914.vue?vue&type=script&lang=js&"
import style0 from "./20240914.vue?vue&type=style&index=0&id=21f88a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f88a64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
